import { useMachine } from '@xstate/react'
import {
  debouncedQueryMachine,
  DebouncedQueryMachineState,
} from 'helpCenter/machines/debouncedQueryMachine'
import { useCallback, useEffect } from 'react'

export const useDebouncedSearch = (
  search: ({ query }: { query: string }) => Promise<{ results: any[] }>
): [any[], (input: { query: string }) => void, DebouncedQueryMachineState] => {
  const [state, send] = useMachine(debouncedQueryMachine)
  useEffect(() => {
    send('SET_FUNCTION', { func: search })
  }, [send, search])
  const request = useCallback(
    (input: { query: string }) => {
      send('SEARCH_CHANGE', {
        input,
      })
    },
    [send]
  )

  const results = state.context.data?.results
  return [results, request, state]
}
